import * as AvatarPrimitive from '@radix-ui/react-avatar';
import { initials } from '@/lib/format';
import { cn } from '@/lib/utils';

export function Avatar({
  name,
  src,
  size = 'md',
  shape = 'circle',
  className,
}: {
  name: string;
  src?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  shape?: 'circle' | 'square';
  className?: string;
}) {
  return (
    <AvatarPrimitive.Root
      className={cn(
        'relative inline-flex shrink-0 select-none items-center justify-center overflow-hidden bg-surface-3 font-medium text-ink-2',
        shape === 'circle' ? 'rounded-full' : 'rounded-sm',
        size === 'xs' && 'size-5 text-[9px]',
        size === 'sm' && 'size-6 text-micro',
        size === 'md' && 'size-7 text-detail',
        size === 'lg' && 'size-10 text-sm',
        className,
      )}
    >
      {src && <AvatarPrimitive.Image src={src} alt="" className="size-full object-cover" />}
      <AvatarPrimitive.Fallback delayMs={src ? 300 : 0}>{initials(name)}</AvatarPrimitive.Fallback>
    </AvatarPrimitive.Root>
  );
}
